import { render, staticRenderFns } from "./UnCheck.vue?vue&type=template&id=b12aac56"
import script from "./UnCheck.vue?vue&type=script&lang=js"
export * from "./UnCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports